import { useLocation } from 'react-router';

import { MAP_ATTRIBUTES_URL, CSV_WIZARD_URL } from 'pages/Directory/consts';

function useIsInWizard() {
  const location = useLocation();
  const { pathname } = location;

  return pathname.includes(MAP_ATTRIBUTES_URL) || pathname.includes(CSV_WIZARD_URL);
}

export default useIsInWizard;
